module.exports = __webpack_public_path__ + "img/1.e38d1272.png";